/* eslint-disable react/no-unused-prop-types */
import { ReactNode } from 'react';
import { Typography } from '@/shared/ui/Typography';
import { classNames } from '@/shared/lib/classNames';
import { useResize } from '@/shared/lib/hooks/useResize/useResize';
import clsBig from './MiniStoryBig.module.scss';
import clsSmall from './MiniStorySmall.module.scss';

type Props = {
    alignment: 'end' | 'start';
    image: string;
    isWatched: boolean;
    title: ReactNode | string;
    onClick: () => void;
};

const MiniStorySmall = ({ title, image, isWatched, onClick }: Props) => {
    const watchedClassname = isWatched ? clsSmall.watched : clsSmall.notWatched;

    return (
        <button className={clsSmall.storyWrapper} type="button" onClick={onClick}>
            <div className={classNames(clsSmall.imageWrapper, {}, [watchedClassname])}>
                <img className={clsSmall.image} alt="story" src={image} />
            </div>
            <Typography className={clsSmall.title} as="p" variant="text_11">
                {title}
            </Typography>
        </button>
    );
};

const MiniStoryBig = ({ title, image, isWatched, alignment, onClick }: Props) => {
    const watchedClassname = isWatched ? clsBig.watched : clsBig.notWatched;

    return (
        <button className={classNames(clsBig.storyWrapper, {}, [watchedClassname])} type="button" onClick={onClick}>
            <div className={clsBig.story} style={{ alignItems: alignment }}>
                <div className={clsBig.title}>{title}</div>
                <img className={clsBig.image} alt="story" src={image} />
            </div>
        </button>
    );
};

export const MiniStory = (props: Props) => {
    const width = useResize();

    return width < 768 ? <MiniStorySmall {...props} /> : <MiniStoryBig {...props} />;
};
